import { useInputCompositionContext } from "../../../../../../hooks/useInputCompositionContext/useInputCompositionContext";
import { useInputDebounce } from "../../../../../../hooks/UseInputDebaunce/UseInputDebaunce";

import HelperService from "../../../../../../frontend.services/Helper.service";

import React, { useState, useMemo } from "react";
import "./SearchDropdown.scss";
import { ClipLoader } from "react-spinners";


const SearchDropdown = ({
    items,
    setStateModel,
    setState,
    field,
    forceClose,
    message,
}) => {
    const [, , isError, setIsError] = useInputCompositionContext();
    const [inputState, setInputState] = useState("");

    // Добавляем debounce для значения input
    const debouncedInput = useInputDebounce(inputState, 300); // задержка

    // Мемоизируем отфильтрованные элементы для оптимизации
    const filteredItems = useMemo(() => {
        if (!items || !Array.isArray(items)) return [];

        return items.filter(elem =>
            elem.fullName.toLowerCase().includes(debouncedInput.toLowerCase())
        );
    }, [items, debouncedInput]);

    function selectHandler(event, listItem) {
        if (isError) {
            setIsError(prev => {
                if (prev[field]) {
                    const temp = prev;
                    delete temp[field];
                    return temp;
                } else {
                    return prev;
                }
            });
        }
        setState(listItem.fullName);
        setStateModel((prev) => {
            return {
                ...prev, [field]: listItem.pid,
            };
        });
        forceClose();
    }

    const handleInputChange = (event) => {
        setInputState(event.target.value);
    };

    if (!items) {
        return (
            <ul className="simple-dropdown-default">
                <li className="simple-dropdown-default__empty-item"><div></div></li>
                <li className="simple-dropdown-default__empty-item"><div></div></li>
                <li className="simple-dropdown-default__empty-item"><div></div></li>
            </ul>
        );
    }

    if (items.length === 0) {
        return (
            <div className={"popup-dropdown-search__no-items"}>
                <span className={"popup-dropdown-search__no-items__text"}>
                    {message || "для замещения нет доступных сотрудников"}
                </span>
            </div>
        );
    }

    return (
        <div className={"popup-dropdown-search"}>
            <input
                onChange={handleInputChange}
                className={"popup-dropdown-search__input"}
                value={inputState}
                type="text"
                placeholder="Поиск..."
            />
            <ul className={"popup-dropdown-search__list"}>
                {filteredItems.map((e, i) => (
                    <li
                        className={"popup-dropdown-search__list__item"}
                        onClick={(event) => selectHandler(event, e)}
                        key={`${e.pid}-${i}`}
                    >
                        <div>{HelperService.getHighlightedText(e.fullName, inputState)}</div>
                        <div>{e.jobTitle}</div>
                        <div>{e.fullStructName}</div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SearchDropdown;
